import { SectionBlock } from "./SectionBlock";
import { ApiKeysManager } from "@/components/profile/ApiKeysManager";

// Settings > External App Integrations (2026-09-09). Same API key management
// as Profile > API Keys — shared via ApiKeysManager — surfaced here because
// wiring up another product (Production Tracker, CI, a bot) is a workspace
// setup task, not a personal preference. Keys stay owner-scoped either way.
export function ExternalAppIntegrationsSection() {
	return (
		<SectionBlock
			title="External App Integrations"
			description="Generate API keys so other apps can create and update work in TaskHub. Each key is bound to one project, carries only the scopes you pick, and keeps a full request history."
		>
			<ApiKeysManager
				heading="API Keys"
				description="Pick the project a key belongs to when you generate it — every request made with that key lands in that project."
			/>
		</SectionBlock>
	);
}
